
import { Component, Prop, Vue } from 'vue-property-decorator';
import { addLevel, addCustomer, editCustomer, getCustomerTagList } from '@/api/customer';
import { UserModule } from '@/store/modules/user';
import pickerAddress from '@/components/PickAddressInMap/index.vue';
import { makeKey } from '@/utils/qiniu';
import { Qiniu } from '@/types/qiniu';
import { getQiniuToken } from '@/api/third';

@Component({
  name: 'CustomerAddDialog',
  components: {
    pickerAddress
  }
})
export default class extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })dialogAddCustomerVisible!:Boolean;
  @Prop({
    type: Number,
    default: 1
  })addType!:any;
  @Prop({
    type: Object,
    default: () => ({})
  })formData!:any;

  private title='添加新客户';
  private showPerson=true;
  private showCompany=true;

  private qiniuDomain: string = 'https://up-z1.qiniup.com';
  private qiniuBean:any = { token: '', key: '', default_url: '', domain: '' }

  private formAddCustomer: any = {
    type: '1',
    company: '',
    people: '',
    mobile: '',
    telephone: '',
    area: '',
    address: '',
    agent: '',
    salesrep: '',
    marketing: '',
    first: '',
    latitude: '',
    longitude: '',
    adcode: '',
    provinceName: '',
    province: '',
    cityName: '',
    city: '',
    districtName: '',
    district: '',
    logo: ''
  }
  private getTagsList() {
    let params:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId
    };
    getCustomerTagList(params).then(res => {
      if (res.data) {
        this.tagOne = res.data.list;
        if (this.formData.customer_tag_id) {
          for (let index = 0; index < this.tagOne.length; index++) {
            const element = this.tagOne[index];
            if (element.id === this.formData.customer_tag_pid) {
              this.tagTwo = this.tagOne[index].list;
            }
          }
        }
      } else {
        this.tagOne = [];
      }
    }).catch(err => {
      let msg = err.msg;
    });
  }
  private tagOne: any = []
  private tag1Change() {
    this.tagTwo = this.formAddCustomer.tag1.list;
    this.$set(this.formAddCustomer, 'tag2', '');
  }
  private tagTwo: any = []

  private showAddressDialog=false
  private isShowEdt2=false;
  created() {
    const params = {
      type: Qiniu.UPLOAD_TYPE_USER
    };
    getQiniuToken(params).then(res => {
      if (res && res.data) {
        this.qiniuBean = res.data;
      }
    });
    this.getTagsList();
    switch (this.addType) {
      case 1:
        this.showPerson = true;
        this.title = '添加新客户';
        break;
      case 2:
        this.title = '编辑客户';
        if (this.formData && this.formData.id) {
          if (parseInt(this.formData.customer_type) === 1) {
            this.showCompany = true;
            this.showPerson = false;
          } else {
            this.showCompany = false;
            this.showPerson = true;
          }
        }
        this.formAddCustomer = {
          type: this.formData.customer_type,
          company: this.formData.name,
          people: this.formData.manager,
          tag1: { id: this.formData.customer_tag_pid, name: this.formData.customer_tag_pname },
          tag2: { id: this.formData.customer_tag_id, name: this.formData.customer_tag_name },
          mobile: this.formData.mobile,
          telephone: this.formData.phone_num,
          area: this.formData.province_name + this.formData.city_name + this.formData.district_name,
          address: this.formData.address,
          agent: this.formData.agent,
          salesrep: this.formData.sales_rep,
          // marketing: this.formData.,
          first: this.formData.is_vip === '1',
          latitude: this.formData.latitude,
          longitude: this.formData.longitude,
          // adcode: this.formData.,
          provinceName: this.formData.province_name,
          province: this.formData.province,
          cityName: this.formData.city_name,
          city: this.formData.city,
          districtName: this.formData.district_name,
          district: this.formData.district,
          logo: this.formData.logo
        };
        if (parseInt(this.formData.is_many_servicer) !== 1 && this.formData.create_customer_company_id === UserModule.getCompanyId) {
          this.isShowEdt2 = false;
        } else {
          this.isShowEdt2 = true;
        }

        break;
      case 3:
        this.showPerson = false;
        this.title = '添加下级客户';
        break;
    }
  }

  private sureAddCustomer() {
    if (!this.formAddCustomer.company) {
      this.showErrorMsg(parseInt(this.formAddCustomer.type) === 1 ? '请输入公司名称' : '请输入联系人');
      return;
    }
    let params:any = {};
    params.company_id = UserModule.getCompanyId ? UserModule.getCompanyId : '0';
    params.user_id = UserModule.getUserId;
    params.name = this.formAddCustomer.company;

    params.type = this.formAddCustomer.type;
    params.customer_type = this.formAddCustomer.type;
    if (parseInt(this.formAddCustomer.type) === 1) {
      params.manager = this.formAddCustomer.people;
    }
    params.mobile = this.formAddCustomer.mobile;
    params.phone = this.formAddCustomer.telephone;
    params.province_name = this.formAddCustomer.provinceName;
    params.province = this.formAddCustomer.province;
    params.city_name = this.formAddCustomer.cityName;
    params.city = this.formAddCustomer.city;
    params.district_name = this.formAddCustomer.districtName;
    params.district = this.formAddCustomer.district;
    params.adcode = this.formAddCustomer.adcode;
    params.latitude = this.formAddCustomer.latitude;
    params.longitude = this.formAddCustomer.longitude;
    params.address = this.formAddCustomer.address;
    params.vip_customer = this.formAddCustomer.first ? '1' : '0';
    params.is_vip = this.formAddCustomer.first ? '1' : '0';
    params.sales_rep = this.formAddCustomer.salesrep;
    params.agent = this.formAddCustomer.agent;
    params.logo = this.formAddCustomer.logo

    if (this.formAddCustomer.tag1 && this.formAddCustomer.tag1.id) {
      params.customer_tag_pname = this.formAddCustomer.tag1.name;
      params.customer_tag_pid = this.formAddCustomer.tag1.id;
    } else {
      params.customer_tag_pid = '';
      params.customer_tag_pname = '';
    }
    if (this.formAddCustomer.tag2 && this.formAddCustomer.tag2.id) {
      params.customer_tag_name = this.formAddCustomer.tag2.name;
      params.customer_tag_id = this.formAddCustomer.tag2.id;
    } else {
      params.customer_tag_name = '';
      params.customer_tag_id = '';
    }
    switch (this.addType) {
      case 1:
        params.add_type = 1;
        addCustomer(params).then(res => {
          this.$emit('closeAddCustomer', false);
          this.showSecussMsg((res as any).msg);
          res.data.customer_type = this.formAddCustomer.type;
          this.$emit('addCustomerHandle', res.data);
        }).catch(err => {
          this.showErrorMsg(err.msg);
        });
        break;
      case 2:
        params.customer_pid = this.formData.customer_company_pid;
        params.customer_id = this.formData.id;
        if (parseInt(this.formAddCustomer.type) === 1) {
          params.customer_company_id = this.formData.customer_company_id;
        } else {
          params.customer_user_id = this.formData.customer_user_id;
        }
        editCustomer(params).then(res => {
          this.$emit('closeAddCustomer', false);
          this.showSecussMsg((res as any).msg);
          this.$emit('addCustomerHandle', { p: params, res: res });
        }).catch(err => {
          this.showErrorMsg(err.msg);
        });
        break;
      case 3:
        params.company_name = this.formAddCustomer.company;
        params.pid = this.formData.customer_company_id;
        addLevel(params).then(res => {
          this.$emit('closeAddCustomer', false);
          this.showSecussMsg((res as any).msg);
          this.$emit('addCustomerHandle', res);
        }).catch(err => {
          this.showErrorMsg(err.msg);
        });

        break;
    }
  }
  private areaCilck() {
    this.showAddressDialog = true;
  }
  // 地图dialog 保存 回调
  private positionPicker(address: any) {
    if (address) {
      this.formAddCustomer.provinceName = address.province_name;
      this.formAddCustomer.province = address.province;
      this.formAddCustomer.cityName = address.city_name;
      this.formAddCustomer.city = address.city;
      this.formAddCustomer.districtName = address.district_name;
      this.formAddCustomer.district = address.district;
      this.formAddCustomer.latitude = address.latitude;
      this.formAddCustomer.longitude = address.longitude;
      this.formAddCustomer.area = address.province_name + '  ' + address.city_name + '  ' + address.district_name;
      this.formAddCustomer.address = address.address;
    }
  }
  // 地图dialog 关闭
  private closeAddress(close: boolean) {
    this.showAddressDialog = close;
  }
  private close() {
    this.$emit('closeAddCustomer', false);
    this.formAddCustomer = {
      type: '1',
      company: '',
      people: '',
      mobile: '',
      telephone: '',
      area: '',
      address: '',
      agent: '',
      salesrep: '',
      marketing: '',
      first: '',
      latitude: '',
      longitude: '',
      adcode: '',
      provinceName: '',
      province: '',
      cityName: '',
      city: '',
      districtName: '',
      district: ''
    };
  }
  private handleAppLogo(res:any) {
    // this.$set()
    this.formAddCustomer.logo = res.key;
  }
  private beforeUpload(file:any) {
    const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
    const isLt2M = file.size / 1024 / 1024 < 5;
    if (!isJPG) {
      return this.$message.error('上传文件只能是  JPG或PNG 格式!');
    }
    if (!isLt2M) {
      return this.$message.error('上传图片大小不能超过 5MB!');
    }
    return new Promise<void>((resolve, reject) => {
      resolve();
    }).then(res => {
      let k = makeKey(this.qiniuBean.prekey);
      this.qiniuBean.key = k;
      this.qiniuBean.token = this.qiniuBean.uptoken;
    });
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSecussMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: window.innerHeight * 0.4,
      customClass: 'notification-center',
      type: 'success'
    });
  }
}
